import {
    AzureKeyVault,
    IAttribute,
    IModel,
    LinkedService,
    Metamodel,
    RestBasedServiceAuthenticationType
} from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: adfModelTypeMap.zendesk.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Zendesk_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Zendesk_DisplayText)
    ]
})
export class ZendeskLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static URL: IAttribute;
    public static USER_NAME: IAttribute;
    public static API_TOKEN: IAttribute;
    public static PASSWORD: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Database_URL,
        templatable: true,
        association: 'URL'
    })
    public url: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType: RestBasedServiceAuthenticationType;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        templatable: true,
        association: 'USER_NAME'
    })
    public userName: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Token,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        templatable: true,
        association: 'API_TOKEN',
        accepts: ['String']
    })
    public apiToken: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        templatable: true,
        association: 'PASSWORD',
        accepts: ['String']
    })
    public password: string | AzureKeyVault;
}
